














import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import { Component } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import CampaignItemPaymentMethods from '@/modules/campaign-item-payment/components/admin/CampaignItemPaymentMethods.vue'
import AvatarUploader from '@/modules/shared/components/shared/form/AvatarUploader.vue'
import { TicketStoreRequestModelInAdmin } from '@/modules/ticket/models/ticket-request.model'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import AdminDepartmentSearch from '@/modules/department/components/admin/AdminDepartmentSearch.vue'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import TicketStatusView from '@/modules/ticket/components/shared/TicketStatusView.vue'
import { Prop } from 'vue-property-decorator'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import AdminCreateTicketForm from '@/modules/ticket/components/admin/AdminCreateTicketForm.vue'

@Component({
  components: {
    AdminCreateTicketForm,
    BaseSelect,
    TicketStatusView,
    MediaUploader,
    AdminDepartmentSearch,
    AdminUserSearch,
    CampaignItemPaymentMethods,
    Modal,
    BaseButton,
    BaseInput,
    Toggle,
    AvatarUploader
  }
})
export default class AdminCreateTicketDialog extends mixins<DialogMixin>(DialogMixin) {

  @Prop() ticket: TicketStoreRequestModelInAdmin
  @Prop() label!: string
  @Prop() isLoading!: boolean

  private dialogModel = false

  onOKClick() {
    this.$emit('ok', this.ticket)
  }

}
